import {getPropertiesPhotoCount} from 'api/reports/comparable/PropertiesPhotoCount';

export const trackPhotoCountsProperties = (comparableSales, comparableListings, properties) => {
  let counts = {upload: 0, aerial: 0, streetView: 0, existing: 0};
  ['sales', 'listings'].forEach((comparableType) => {
    const comparables = comparableType === 'sales' ? comparableSales : comparableListings;
    if (comparables) {
      getPropertiesPhotoCount(comparables, counts);
    }
  });
  properties.push({label: 'Photo Type Uploaded', value: counts.upload});
  properties.push({label: 'Photo Type Aerial', value: counts.aerial});
  properties.push({label: 'Photo Type Street View', value: counts.streetView});
  properties.push({label: 'Photo Type Existing Image', value: counts.existing});
};